module.exports = __webpack_public_path__ + "img/caret-left-fill.33d80ead.svg";